import handleRoutes from '@/composabels/useHandleRoutes';
import { createRouter, createWebHistory } from 'vue-router';

const routes = handleRoutes();
const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

export default router;
